import {
  IonButton,
  IonContent,
  IonHeader,
  IonPage,
  IonText,
  IonTitle,
  IonToolbar,
  IonTextarea,
  IonItem,
  IonNote,
  IonIcon,
  useIonToast,
  IonButtons,
} from '@ionic/react';
import { clipboard, close, document, save, sync } from 'ionicons/icons';
import { useState } from 'react';
import { useRecoilState } from 'recoil';
import { doCopy, setLocalStorage } from '../helper';
import { historyStore } from '../store';

import './Tab1.css';

const Tab1: React.FC = () => {
  const [input, setInput] = useState<string>('');
  const [AaAfter, setAaAfter] = useState<string>('');
  const [overLine, setOverLine] = useState<string[]>([]);
  const [isOverLength, setIsOverLength] = useState<boolean>(false);
  const [history, setHistory] = useRecoilState<string[]>(historyStore);
  const [present, dismiss] = useIonToast();
  const rows = 8;
  const splitLine = (w: string) => {
    // textareaから1文字ずつ取得
    const word = w.replace(/\r\n|\r/g, '\n'); // 他の改行コードを/nに変換
    const lines = word.split('\n');
    const outArray: string[] = new Array();

    for (let i = 0; i < lines.length; i++) {
      let line: string = lines[i];
      // 末尾空白の削除
      while (line.slice(-1) === ' ' || line.slice(-1) === '　') {
        line = line.slice(0, -1);
      }
      outArray.push(line);
    }
    while (true) {
      if (outArray[outArray.length - 1] === '') {
        outArray.pop();
        continue;
      }
      break;
    }
    return outArray;
  };
  const byteCount = (w: string) => {
    let bytes: number = 0;
    for (let i = 0; i < w.length; i++) {
      if (w[i].match(/[ -~]/)) {
        bytes += 1;
      } else {
        bytes += 2;
      }
    }
    bytes += 1;
    return bytes;
  };
  const doTrance = () => {
    const result: string[] = [];
    const over: string[] = [];
    for (let line of splitLine(input)) {
      // バイト数が30になるまで、末尾に空白を追加
      // 120文字までなので、全角を優先
      //行末を除外
      if (result.length !== splitLine(input).length - 1) {
        while (byteCount(line) < 30) {
          if (byteCount(line) === 29) line = line + ' ';
          else line = line + '　';
        }
      }

      // 連続半角スペースを全角スペースへ変換
      line = line.replace('  ', '　');

      if (byteCount(line) > 30) over.push(line);

      setOverLine(over);
      result.push(line);
    }

    if (result.join('').length > 120) setIsOverLength(true);
    else setIsOverLength(false);

    setAaAfter(result.join('\n'));
  };

  const doSave = () => {
    const tmp = history.slice();
    tmp.unshift(AaAfter);
    setHistory(tmp);
    setLocalStorage('history', tmp);
    present({
      buttons: [{ text: 'OK', handler: () => dismiss() }],
      message: '保存しました。',
      duration: 1000,
      color: 'dark',
      position: 'middle',
    });
  };

  const copyHandle = () => {
    doCopy(AaAfter);
    present({
      buttons: [{ text: 'OK', handler: () => dismiss() }],
      message: 'コピーしました',
      duration: 1000,
      color: 'dark',
      position: 'middle',
    });
  };

  const doPaste = () => {
    if (navigator.clipboard) {
      navigator.clipboard.readText().then(function (text) {
        setInput(text);
      });
    }
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>放置少女AA変換　旧 → 新(β)</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div style={{ margin: '5px' }}>
          <IonText>
            ↓にAAを入力してください。あらかじめ改行されているAAのみ対応しています。
          </IonText>
          <div style={{ border: 'solid 1px black' }}>
            <IonTextarea
              rows={rows}
              value={input}
              onInput={(e: any) => setInput(e.target.value)}
            >
              <IonButtons className='function-buttons-bottom'>
                <IonButton onClick={() => doPaste()}>
                  <IonIcon icon={clipboard} />
                  ペースト
                </IonButton>
                <IonButton disabled={true} onClick={() => setInput('')}>
                  <IonIcon icon={close} />
                  クリアー
                </IonButton>
              </IonButtons>
            </IonTextarea>
          </div>
          <IonButton
            expand='block'
            onClick={() => doTrance()}
            disabled={input === ''}
          >
            <IonIcon slot='start' icon={sync} />
            変換
          </IonButton>
          <IonText id='result'>変換結果</IonText>
          <div style={{ border: 'solid 1px black' }}>
            <IonTextarea
              rows={rows}
              value={AaAfter}
              onInput={(e: any) => setAaAfter(e.target.value)}
            >
              <IonButtons className='function-buttons-bottom'>
                <IonButton
                  onClick={() => copyHandle()}
                  disabled={AaAfter === ''}
                >
                  <IonIcon icon={document} />
                  コピー
                </IonButton>
              </IonButtons>
            </IonTextarea>
          </div>

          {isOverLength && (
            <>
              <IonText color='primary'>
                全体が120文字を超えています(たぶん)
              </IonText>
              <br />
            </>
          )}
          {overLine.length !== 0 && (
            <IonText color='danger'>
              横幅がオーバーしています。30byteまで削って下さい。
            </IonText>
          )}
          {overLine.map((line, index) => (
            <IonItem key={line + '-number' + index}>
              <IonNote>{byteCount(line) + '文字'}</IonNote>
              <IonText>{line}</IonText>
            </IonItem>
          ))}
          <IonButton
            disabled={AaAfter === ''}
            expand='block'
            onClick={() => doSave()}
          >
            <IonIcon slot='start' icon={save} />
            結果を保存
          </IonButton>
          {AaAfter.length !== 0 && <IonText>全体{AaAfter.length}文字</IonText>}
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Tab1;
